export default __webpack_public_path__ + "static/media/topic-fill-gray5-48.057f5624.svg";